<template>
  <div class="level">
    <h1 v-if="this.$route.params.areaId == 1">Vocabulary</h1>
    <h1 v-else-if="this.$route.params.areaId == 2">Listening</h1>
    <h1 v-else>Speaking</h1>
    <div class="container" v-if="loaded">
      <div class="card card-add" v-if="level.length !== 3" @click="postLevel">
        <i class="fa-solid fa-plus" style="color: var(--main-color); font-size: 35px"></i>
        <p>Crear Nivel</p>
      </div>

      <div class="card card-add" v-for="(item, index) in level" :key="index" @click="goToRoute(item.id)">
        <p class="card-title">{{ item.name }}</p>
      </div>
    </div>
    <div class="container" v-else>
      <img src="../assets/loading.gif" alt="Loading" style="height: 200px; height: 200px; padding: 10px;">
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "LevelView",
  data() {
    return {
      level: [],
      levelData: {
        name: "",
      },
      loaded: false,
    };
  },
  mounted() {
    this.getLevel();
  },
  methods: {
    async getLevel() {
      try {
        const response = await this.$axios.get(
          "levels/unities/" +
          this.$route.params.id
        );
        //console.log("Respuesta del servidor:", response.data);
        this.level = response.data.content;
        this.loaded = true;
      } catch (error) {
        //console.error("Error al realizar la solicitud GET:", error);
      }
    },
    async postLevel() {
      this.levelData.name = "Nivel " + (this.level.length + 1);
      this.loaded = false;
      try {
        const response = await this.$axios.post(
          "levels/" + this.$route.params.id,
          this.levelData
        );
        //console.log("Respuesta del servidor:", response.data);
        this.loaded = true;
        this.level = response.data;
        this.getLevel();
      } catch (error) {
        //console.error("Error al realizar la solicitud GET:", error);
      }
    },
    goToRoute(route) {
      router.push("/level/" + route);
    },
  },
};
</script>

<style scoped>
.level {
  flex: 1;
  background-color: var(--not-so-grey);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

p {
  margin: 0;
}

.container {
  width: 70%;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}

.card {
  cursor: pointer;
  background-color: #f4f8f7;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  width: 200px;
  height: 200px;
  padding: 10px;
  gap: 10px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: all ease-out 0.5s;
  -webkit-transition: all ease-out 0.5s;
  -moz-transition: all ease-out 0.5s;
  -ms-transition: all ease-out 0.5s;
  -o-transition: all ease-out 0.5s;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
}

.card-content {
  color: var(--another-grey);
}

.card-content-other {
  font-style: italic;
}

.card-add {
  align-items: center;
  justify-content: center;
}

.card:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
}
</style>